import is_not_empty from "./is_not_empty";

const format_date_short = function (timestamp) {
  const language = localStorage?.language || "ina";
  const date = new Date(timestamp);

  const tanggal = date.getDate();
  const bulan = date.getMonth();
  const tahun = date.getFullYear();

  if (!tanggal || !is_not_empty(bulan) || !tahun) return null;

  const months_ina = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MEI",
    "JUNI",
    "JULI",
    "AGT",
    "SEP",
    "OKT",
    "NOV",
    "DES",
  ];

  const months_eng = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUNE",
    "JULY",
    "AUG",
    "SEPT",
    "OCT",
    "NOV",
    "DEC",
  ];
  let months_array;
  if (language === "ina") {
    months_array = months_ina;
  } else {
    months_array = months_eng;
  }


  let month_final = months_array[bulan];
  let date_final = tanggal + " " + month_final + " " + tahun;
  return date_final;
};

export default format_date_short;
